<template>
  <div class="match-invite-page page">
    <!-- 主体 -->
    <Breadcrumb :type="1" />
    <div class="detail-content">
      <div class="detail-title">{{ article.articleName || '' }}</div>
      <div class="detail-date">发布日期：{{ article.releaseTime || '--' }}</div>
      <div class="detail-hr"></div>
      <div class="article-content" v-html="article.articleContent"></div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/breadcrumb'
import { getArticleById } from '@/api/home/home.js'
import { fixMedia } from '@/utils/util'
export default {
  components: { Breadcrumb },
  data() {
    return {
      article: {
        releaseTime: ''
      },

      id: null
    }
  },
  methods: {
    // 文章信息--富文本
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return
        this.article = res.data
        this.article.articleContent = fixMedia(res.data.articleContent)
      })
    }
  },
  created() {
    this.id = this.$route.query?.id
    this.getArticleData(this.id)
  }
}
</script>

<style lang="scss" scoped>
.match-invite-page {
  display: flex;
  flex-direction: column;
  .detail-content {
    display: flex;
    flex-direction: column;
    width: 1340px;
    margin: 64px auto 120px;
    .side-content {
      display: flex;
      flex-direction: column;
      .side-flex {
        min-height: 22px;
        line-height: 22px;
        display: flex;
        flex-direction: row;
        font-size: 16px;
        .flex-title {
          color: #111;
          flex: 1;
        }
        .flex-title-active {
          color: #005bac;
          cursor: pointer;
        }
        .flex-text {
          color: 111;
        }
      }
      .side-flex:last-child {
        margin-top: 16px;
      }
    }
    .detail-area {
      background: #f9fafb;
      height: 38px;
      margin: 42px 0 10px;
    }
    .article-content {
      color: #111;
      font-size: 20px;
      line-height: 44px;
      word-break: break-all;
    }
    .detail-hr {
      border-top: 1px solid #e6e6e6;
      margin: 36px 0 42px;
    }
    .detail-date {
      text-align: center;
      margin-top: 24px;
      color: #5c5c5c;
      font-size: 16px;
      height: 22px;
      line-height: 22px;
    }
    .detail-title {
      line-height: 27px;
      color: #111;
      font-size: 28px;
      font-weight: 600;
      text-align: center;
    }
  }
}

// 手机端css
.mobile-content {
  .match-invite-page {
    .detail-content {
      width: 345px;
      margin: 20px auto 60px;
      .side-content {
        .side-flex {
          font-size: 13px;
        }
        .side-flex:last-child {
          margin-top: 10px;
        }
      }
      .detail-area {
        height: 19px;
        margin: 21px 0 10px;
      }
      .article-content {
        font-size: 14px;
        line-height: 22px;
        img {
          width: 100%;
        }
      }
      .detail-hr {
        margin: 18px 0 21px;
      }
      .detail-date {
        margin-top: 12px;
        font-size: 12px;
        line-height: 18px;
        height: 18px;
      }
      .detail-title {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
}
</style>
